import * as React from "react";

function SvgCustomerio(props, ref) {
  return (
    <svg
      viewBox="0 0 118.6 83.4"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <defs>
        <path id="customerio_svg__a" d="M-87.6 0h293v142h-293z" />
      </defs>
      <clipPath id="customerio_svg__b">
        <use xlinkHref="#customerio_svg__a" overflow="visible" />
      </clipPath>
      <g clipPath="url(#customerio_svg__b)">
        <path
          d="M59.2 47.5c13 0 23.5-10.5 23.5-23.5S72.2.5 59.2.5 35.6 10.9 35.6 23.9c0 13 10.6 23.6 23.6 23.6z"
          fill="#ffcd00"
        />
        <path
          d="M59.3 59.2c-16.6 0-30.4-11.3-34.3-26.6-1.2-4.7-5-8.7-9.9-8.7H.4c0 32.5 26.3 58.8 58.8 58.8h.1V59.2z"
          fill="#00ecbb"
        />
        <path
          d="M59.2 59.2c16.6 0 30.4-11.3 34.3-26.6 1.2-4.7 5-8.7 9.9-8.7h14.7c0 32.5-26.3 58.8-58.8 58.8h-.1V59.2z"
          fill="#af64ff"
        />
        <path
          d="M100.8 65.5C90.2 76.2 75.5 82.8 59.2 82.8s-31-6.6-41.6-17.2L34.2 49c6.4 6.4 15.2 10.3 25 10.3 9.7 0 18.6-4 25-10.3l16.6 16.5z"
          fill="#7131ff"
        />
      </g>
    </svg>
  );
}

export default React.forwardRef(SvgCustomerio);
